const selectors$l = {
    section: "data-section-type",
    shareButton: "[data-share-button]",
    shareMessage: "[data-share-message]",
  },
  classes$f = { visible: "is-visible" };
class ShareButton extends HTMLElement {
  constructor() {
    super(),
      (this.container = this.closest(`[${selectors$l.section}]`)),
      (this.shareButton = this.querySelector(selectors$l.shareButton)),
      (this.shareMessage = this.querySelector(selectors$l.shareMessage)),
      (this.urlToShare = this.shareButton.dataset.shareUrl
        ? this.shareButton.dataset.shareUrl
        : document.location.href),
      this.init(),
      this.updateShareLink();
  }
  init() {
    const isMobile = this.isMobileDevice();

    navigator.share && isMobile
      ? this.shareButton.addEventListener("click", () => {
          navigator.share({ url: this.urlToShare, title: document.title });
        })
      : this.shareButton.addEventListener(
          "click",
          this.copyToClipboard.bind(this),
        );
  }
  isMobileDevice() {
    const ua = navigator.userAgent;

    const isTablet = /iPad|Tablet|PlayBook|Silk|(Android(?!.*Mobile))/i.test(
      ua,
    );
    const isMobile =
      /iPhone|Android.*Mobile|Windows Phone|webOS|BlackBerry|Opera Mini|IEMobile/i.test(
        ua,
      );

    if (isTablet || isMobile) {
      return true;
    }
    return false;
  }

  updateShareLink() {
    this.container.getAttribute(selectors$l.section) == "product" &&
      this.container.addEventListener("theme:variant:change", (event) => {
        event.detail.variant &&
          (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${event.detail.variant.id}`);
      });
  }
  copyToClipboard() {
    navigator.clipboard.writeText(this.urlToShare).then(() => {
      this.shareMessage.classList.add(classes$f.visible);
      const removeVisibleClass = () => {
        this.shareMessage.classList.remove(classes$f.visible),
          this.shareMessage.removeEventListener(
            "animationend",
            removeVisibleClass,
          );
      };
      this.shareMessage.addEventListener("animationend", removeVisibleClass);
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (!customElements.get('share-button')) {
    customElements.define('share-button', ShareButton);
  }
});